import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchRefinersToggled = action(
    'onSearchRefinersToggled',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export default onSearchRefinersToggled;
